module.exports = __webpack_public_path__ + "img/hint.44902a65.png";